<template>
  <v-container class="notification">
    <div class="title-icon">
      <v-btn x-small text @click="$emit('readNotes')" class="title">
        <v-icon>$sl-save</v-icon>
        <h1>{{ $t('notifications.mark-read') }}</h1>
      </v-btn>
      <v-icon class="mt-1" small @click="$emit('close')">$sl-close</v-icon>
    </div>

    <NotificationList @clickNote="$events.fire('readNote', arguments[0])" @closeModal="$emit('close')" />

    <div class="footer">
      <v-btn x-small text @click="$emit('showSettings')">
        <v-icon class="mr-2">$sl-settings</v-icon>
        {{ $t('settings.settings-title') }}
      </v-btn>
      <v-btn x-small text @click="$emit('showNotes')">
        <v-icon class="mr-2">$sl-bullets</v-icon>
        {{ $t('notifications.show-all') }}
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import NotificationList from '@/components/Notifications/NotificationList'
// @group Notifications
// NotificationDialog component
export default {
  name: 'NotificationDialog',
  components: {
    NotificationList
  }
}
</script>
